import { Navigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

/** Prevents the user from accessing the website if they are signed in as an agent */
export default function BlockWebGuard({ children }: { children: React.ReactNode }) {
  const { data: user } = useMyUserData()

  const shouldBlock = user?.role === 'admin' ? false : true

  if (shouldBlock) {
    return <Navigate to={paths.alert.path} replace />
  }

  return <>{children}</>
}
